<template>
  <main>
    <div class="container">
      <div class="row py-3 py-sm-5">
        <div class="col-12">
          <h1 class="text-white text-center">
            Contact
          </h1>
        </div>
      </div>
    </div>

    <div class="container-fluid bg-white py-5">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h3 class="text-center">
              Send us a message
            </h3>
            <hr>
            <notifications />
            <form
              ref="form"
              @submit.prevent="sendMessage"
            >
              <div class="form-group row">
                <label
                  for="email"
                  class="col-md-4 col-form-label text-md-right"
                >Email</label>
                <div class="col-md-6">
                  <input
                    id="email"
                    v-model="form.email"
                    type="text"
                    class="form-control"
                    required
                    autofocus
                    placeholder="Enter Email"
                  >
                </div>
              </div>

              <div class="form-group row">
                <label
                  for="subject"
                  class="col-md-4 col-form-label text-md-right"
                >Subject</label>
                <div class="col-md-6">
                  <input
                    id="subject"
                    v-model="form.subject"
                    type="text"
                    class="form-control"
                    required
                    placeholder="Enter Subject"
                  >
                </div>
              </div>

              <div class="form-group row">
                <label
                  for="message"
                  class="col-md-4 col-form-label text-md-right"
                >Message</label>
                <div class="col-md-6">
                  <textarea
                    id="message"
                    v-model="form.message"
                    cols="30"
                    rows="10"
                    required
                    class="form-control"
                    placeholder="Enter Message"
                  />
                </div>
              </div>

              <div class="form-group row mb-4">
                <div class="col-md-6 offset-md-4">
                  <NotARobotButton v-model="form.recaptcha_response" />
                </div>
              </div>

              <div class="form-group row mb-0">
                <div class="col-md-6 offset-md-4">
                  <button
                    type="submit"
                    class="btn btn-primary btn-lg"
                  >
                    Send
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Contact from '../services/contact.js';
import NotARobotButton from "../components/NotARobotButton";

export default {
  components: {
    NotARobotButton,
  },
  data: () => {
    return {
      form: {
        email:'',
        subject:'',
        message:'',
        recaptcha_response: '',
      },
    }
  },
  methods: {
    sendMessage(){
      if (this.$refs.form.checkValidity()){
        Contact.sendContact(this.form).then(res => {
          this.$store.dispatch('notifications/setSuccess', 'Message sent!');
        }).catch(err => {
          this.$store.dispatch('notifications/setError', err.response.data.message || 'There was an error.')
          this.$store.dispatch('notifications/setErrorBag', err.response.data.errors);
        });
      } else {
        this.$refs.form.reportValidity();
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
